import { t } from "/global/js/translations.min.js?v=1743070040";
import SendEmail from "/global/js/sendEmail.min.js?v=1743070040";
export default class ContactFormsCustomFields {
  constructor(id) {
    this.id = id;
    this.module = document.querySelector("#" + this.id);
    this.module.style.minHeight = '100px';
    this.parent = this.module.parentNode;
    this.settings = JSON.parse(decodeURIComponent(this.parent.dataset.settings));
    this.ajaxHandler = '/content/plugins/departments/ajaxHandlerDepartments.php';
    this.isDepartmentPage = document.body.classList.contains('departmentPage');
    (async () => {
      this.t = await t;
      if (!this.settings.general.email && !this.settings.general.emailCategory && !this.settings.general?.useDepartments && this.settings.general.useDepartments === 0 || !this.settings.general.subject) {
        console.error("Form is missing email, category or subject");
        return;
      }
      this.module.innerHTML = `
                <div class="col-12">
                    <form action="" method="post">
                        <div class="row g-3">

                        </div>
                    </form>
                </div>
            `;
      this.formRow = this.module.querySelector('form .row');
      if (this.settings.general?.useDepartments === 1) {
        const response = this.isDepartmentPage ? await this.getDepartmentByUrl() : await this.getDepartments();
        if (response.error) return;
        const departmentsSorted = response.departments;
        const departmentsDiv = document.createElement('div');
        departmentsDiv.classList.add('h-100', 'd-flex', 'flex-column', 'justify-content-end');
        const departmentsInputGroup = document.createElement('div');
        departmentsInputGroup.classList.add('input-group');
        this.departmentsSelect = document.createElement('select');
        this.departmentsSelect.classList.add('form-select');
        departmentsDiv.append(departmentsInputGroup);
        departmentsInputGroup.append(this.departmentsSelect);
        for (const [departmentCategory, departments] of Object.entries(departmentsSorted)) {
          const optgroup = document.createElement('optgroup');
          optgroup.label = departmentCategory;
          for (const department of departments) {
            if (department.depaEmailBookTableEncrypted && department.depaName) {
              const option = document.createElement('option');
              option.value = department.depaEmailBookTableEncrypted;
              option.innerHTML = department.depaName;
              optgroup.append(option);
            }
          }
          this.departmentsSelect.append(optgroup);
        }
        this.formRow.append(departmentsDiv);
      }
      if (this.settings?.elements) {
        for (const element of Object.values(this.settings.elements)) {
          const specialTypes = ["textarea", "select", "departments", "openHoursDate", "openHoursDateTime"];
          const elementHtml = document.createElement('div');
          element?.size?.mobile ? elementHtml.classList.add(element?.size?.mobile) : "";
          element?.size?.md ? elementHtml.classList.add(element?.size?.md) : "";
          element?.size?.lg ? elementHtml.classList.add(element?.size?.lg) : "";
          elementHtml.innerHTML = `
                        <div class="h-100 d-flex flex-column justify-content-end">
                            ${element?.label ? `
                                <label class="${element?.required ? "required" : ""}">${element.label}</label>
                            ` : ""}

                            <div class="input-group">
                                ${element?.icon ? `<span class="input-group-text">${element.icon}</span>` : ""}

                                ${!specialTypes.includes(element.type) ? `
                                    <input type="${element.type}" class="form-control" name="data[${element.fieldName}]" ${element?.minNumber ? 'min="' + element.minNumber + '"' : ""} ${element?.maxNumber ? 'max="' + element.maxNumber + '"' : ""} placeholder="${element?.placeholder ? element.placeholder + `${element?.required ? "*" : ""}` : ""}" autocomplete="${element?.autocomplete ? element.autocomplete : ""}" ${element?.required ? "required" : ""}>
                                ` : ""}

                                ${element?.type === "textarea" ? `
                                    <textarea class="form-control" name="data[${element.fieldName}]" placeholder="${element?.placeholder ? element.placeholder : ""}" style="height:100px;" ${element?.required ? "required" : ""}></textarea>
                                ` : ""}

                                ${element?.type === "select" ? `
                                    <select class="form-select" name="data[${element.fieldName}]" ${element?.required ? "required" : ""}>
                                        ${element?.options && Object.values(element.options).length > 0 ? element.options.map(option => `<option>${option}</option>`).join('') : ""}
                                    </select>
                                ` : ""}

                                ${element?.type === "openHoursDate" || element?.type === "openHoursDateTime" ? `
                                    <input type="date" class="form-control openHoursDate" name="data[${element.fieldName}]" placeholder="${element?.placeholder ? element.placeholder + `${element?.required ? "*" : ""}` : ""}" ${element?.required ? "required" : ""}>
                                ` : ""}
                            </div>
                        </div>
                    `;
          if (element?.type === "openHoursDate" || element?.type === "openHoursDateTime") {
            const response = await this.getOpenHours();
            if (response.error) return;
            const dateFormatter = new Intl.DateTimeFormat('da-DK', {
              dateStyle: 'short',
              //full, long, medium, short
              timeStyle: 'short' //full, long, medium, short
            });
            const enableDates = [];
            const enableDateObjects = [];
            if (response.openHours.length > 0) {
              for (const openHour of response.openHours) {
                enableDates.push(new Date(openHour.ophoDate));
                let date, minTime, maxTime;
                date = new Date(openHour.ophoDate);
                date.setHours(0, 0, 0, 0);
                if (openHour?.ophoTimeStartBooking) {
                  minTime = openHour.ophoTimeStartBooking;
                } else if (openHour?.ophoTimeStart) {
                  minTime = openHour?.ophoTimeStart;
                }
                if (openHour?.ophoTimeEndBooking) {
                  maxTime = openHour.ophoTimeEndBooking;
                } else if (openHour?.ophoTimeEnd) {
                  maxTime = openHour?.ophoTimeEnd;
                }
                enableDateObjects.push({
                  date,
                  minTime,
                  maxTime
                });
              }
            }
            let dateFormat = this.t.country.counDateTimeFormat.date.medium;
            if (element.type === "openHoursDateTime") {
              dateFormat = this.t.country.counDateTimeFormat.date.medium + ' ' + this.t.country.counDateTimeFormat.time.short;
            }
            const openHoursElem = elementHtml.querySelector('.openHoursDate');
            flatpickr(openHoursElem, {
              dateFormat: dateFormat,
              weekNumbers: true,
              disableMobile: true,
              minDate: enableDates[0],
              enable: enableDates,
              enableTime: element.type === "openHoursDateTime",
              time_24hr: true,
              minuteIncrement: 15,
              onChange: (selectedDates, dateStr, instance) => {
                if (selectedDates.length > 0) {
                  if (element.type === "openHoursDateTime" && enableDateObjects.length > 0) {
                    //selectedDates klones for ikke at ændre tiden på kalenderen ved .setHours(0,0,0,0);
                    const selected = structuredClone(selectedDates[0]);
                    selected.setHours(0, 0, 0, 0);
                    for (const enableDateObject of enableDateObjects) {
                      if (enableDateObject.date.getTime() === selected.getTime()) {
                        instance.set('minTime', enableDateObject.minTime);
                        instance.set('maxTime', enableDateObject.maxTime);
                        break;
                      }
                    }
                  }
                }
              },
              onReady: (selectedDates, dateStr, instance) => instance._input.readOnly = false,
              onOpen: (selectedDates, dateStr, instance) => instance._input.readOnly = true,
              onClose: (selectedDates, dateStr, instance) => instance._input.readOnly = false
            });
          }
          this.formRow.append(elementHtml);
        }
        this.submitBtnCol = document.createElement('div');
        this.submitBtnCol.classList.add("col-md-4", "offset-md-8");
        this.submitBtnCol.innerHTML = `<button type="submit" class="btn btn-primary w-100">${this.t.__("Send")}</button>`;
        this.submitBtn = this.submitBtnCol.querySelector('.btn');
        this.formRow.append(this.submitBtnCol);
        this.forms = this.module.querySelectorAll('form');
        this.forms[0].addEventListener('submit', e => this.formSubmit(e));
      }
    })();
  }
  async getDepartments() {
    const request = await fetch(this.ajaxHandler + '?handler=getDepartments');
    return await request.json();
  }
  async getDepartmentByUrl() {
    const request = await fetch(this.ajaxHandler + '?handler=getDepartmentByUrl');
    return await request.json();
  }
  async getOpenHours() {
    const formData = new FormData();
    const date = new Date();
    let currentYear = date.getFullYear();
    for (const year of [currentYear, ++currentYear]) {
      formData.append('years[]', year);
    }
    formData.append('ajaxToken', window.ajaxToken);
    const request = await fetch('/content/plugins/openHours/ajaxHandlerOpenHours.php?handler=getOpenHours', {
      method: "POST",
      body: formData
    });
    return await request.json();
  }
  formSubmit(e) {
    e.preventDefault();
    this.submitBtn.disabled = true;
    const sendEmail = new SendEmail(this.forms[0]);
    this.formDataExtra = {};
    this.sendToEmail = this.settings?.general?.email;
    if (this.settings.general?.useDepartments === 1) {
      this.sendToEmail = this.departmentsSelect.value;
      this.formDataExtra = {
        'data[Pub]': this.departmentsSelect[this.departmentsSelect.selectedIndex].textContent
      };
    }
    grecaptcha.ready(async () => {
      const token = await grecaptcha.execute(window.siteKey, {
        action: 'submit'
      });
      const mailIsSent = await sendEmail.send(token, {
        sendToEmail: this.sendToEmail,
        showInCms: this.settings?.general?.showInCms ? this.settings.general.showInCms : 0,
        emailCategory: this.settings?.general?.emailCategory ? this.settings.general.emailCategory : "",
        subject: this.settings.general.subject,
        successMsg: this.settings?.general?.successMsg ? this.settings.general.successMsg : "",
        formDataExtra: this.formDataExtra
      });
      if (mailIsSent) {
        this.submitBtn.disabled = false;
      }
    });
  }
}